// Buffy → Create Assignments handoff (2026-09-23). A teacher asks any Buffy chat
// to assign something; the "Draft it with me" chip stores the request here and
// opens Create Assignments, where the assignment chat (also Buffy) drafts it.
// In memory only, never in the URL: a shared link can't pre-fill anyone's
// draft, and nothing is assigned until the teacher presses the final button.
const MAX_AGE_MS = 5 * 60 * 1000;
let pending = null;

export function setAssignHandoff(request, type = 'homework') {
  pending = { request: String(request || '').replace(/\s+/g, ' ').trim().slice(0, 1000), type: type === 'unit' ? 'unit' : 'homework', at: Date.now() };
}

// One use: the Create Assignments chat takes it once, then it is gone.
export function takeAssignHandoff() {
  const p = pending;
  pending = null;
  return p && Date.now() - p.at < MAX_AGE_MS ? p : null;
}

export const assignHandoffPath = (type) => `/teacher-dashboard/assignments?assign=${type === 'unit' ? 'unit' : 'new'}`;
